import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7a75656a: FaireBrandEntity = {
  token: "b_7a75656a",
  type: "brand",
  name: "Rewined",
  avatarUrl:
    "https://cdn.faire.com/fastly/32a1ac283bb7334fa16a61f11b90599206238544d81cd7af4a04f85be4743db5.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/41060746e0957a8e59cb4565ef258eb466a5795fde0579ee2f3b744521dd4573.png",
  logoUrl:
    "https://cdn.faire.com/fastly/32a1ac283bb7334fa16a61f11b90599206238544d81cd7af4a04f85be4743db5.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/41060746e0957a8e59cb4565ef258eb466a5795fde0579ee2f3b744521dd4573.png",
  location: "Charleston, SC, USA",
  minimumOrderDollars: 200,
  rating: 4.9,
  reviewCount: 626,
  isInsider: true,
  description:
    "Rewined is a fragrant state of mind - a way of savoring and celebrating wine, food, people, seasons and place through the senses and imagination. Every thoughtfully designed collection is a labor of love - stories shaped and shared by many hands - beautiful manifestations of care, craftsmanship and commitment to quality. Made in Charleston, SC, its own feast for the senses, Rewined sparks memories and emotions, conjures, illuminates, sets the table, lights the candles, and invites us all to raise our glasses. ",
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:06:21.893Z",
    importedBy: "entity-db-cli",
  },
};
